import { atom } from "recoil";
import { UserInfo } from "./types";

export const userInfoAtom = atom<UserInfo | undefined>({
  key: "userInfo",
  default: undefined,
});
